export default __webpack_public_path__ + "static/survival_of_species-304711b651900f2c340cd2387ad8b17c.jpg";